import styled from 'styled-components';

import { media } from '@/utils';

interface ContainerProps {
    $isSmall?: boolean;
    $alignLeft?:boolean;
    $maxWidth?: string;
    $tightTop?: boolean;
}

export const Container = styled.div<ContainerProps>`
  margin: ${({ $alignLeft, $tightTop }) => {
    const top = $tightTop ? '4px' : '25px';
    const sides = $alignLeft ? '0' : 'auto';
    return `${top} ${sides} 25px`;
  }};
  width: 100%;
  padding: 0 64px;
  max-width: ${({ $maxWidth, $isSmall }) => $maxWidth ?? ($isSmall ? '1000px' : '1800px')};
  min-height: calc(100vh - 200px);

  ${media.tabletDown} {
    margin: ${({ $tightTop }) => ($tightTop ? '0 auto 0' : '0 auto')};
    padding: 10px 15px 70px;
    min-height: auto;
  }
`;
